const COLORS = {
    primary: "#094C43",
    secondary: "#E65402",
};

export default COLORS;
